import { render } from "./AppTable.vue?vue&type=template&id=3c6caccf&scoped=true"
import script from "./AppTable.vue?vue&type=script&lang=js"
export * from "./AppTable.vue?vue&type=script&lang=js"

import "./AppTable.vue?vue&type=style&index=0&id=3c6caccf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6caccf"]])

export default __exports__